import React, { useState, useEffect } from 'react';
import { Download, Book } from 'lucide-react';
import LibraryTab from './LibraryTab';
import UploadTab from './UploadTab';
import useSuperAdminContentManagementStore from '@/stores/SuperAdminStore/SuperAdminContentManagementStore';
import './ContentManagement.css';

const ContentManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('upload');

  const {
    libraryContent,
    recentUploads,
    categories,
    fetchLibraryContent,
    fetchRecentUploads,
    fetchCategories,
  } = useSuperAdminContentManagementStore();

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'library' && !libraryContent) {
      fetchLibraryContent();
    }
  }, [activeTab, libraryContent, fetchLibraryContent]);

  useEffect(() => {
    if (activeTab === 'upload' && !recentUploads) {
      fetchRecentUploads();
    }
    if (activeTab === 'upload' && !categories) {
      fetchCategories();
    }
  }, [activeTab, recentUploads, categories, fetchRecentUploads, fetchCategories]);

  return (
    <div className="s-admin-content-management-container">
      {/* Breadcrumb */}
      <div className="s-admin-content-management-breadcrumb">
        Content Management › Upload & Library
      </div>

      {/* Page Header */}
      <div className="s-admin-content-management-page-header">
        <h1>Content Management</h1>
        <p className="s-admin-content-management-subtitle">
          Upload, organize, and manage your learning content assets
        </p>
      </div>

      {/* Tabs */}
      <div className="s-admin-content-management-tabs">
        <button
          className={`s-admin-content-management-tab ${activeTab === 'upload' ? 's-admin-content-management-tab-active' : ''}`}
          onClick={() => setActiveTab('upload')}
        >
          <Download size={18} />
          <span>Upload New</span>
        </button>
        <button
          className={`s-admin-content-management-tab ${activeTab === 'library' ? 's-admin-content-management-tab-active' : ''}`}
          onClick={() => setActiveTab('library')}
        >
          <Book size={18} />
          <span>Library</span>
        </button>
      </div>

      {/* Tab Content */}
      <div className="s-admin-content-management-tab-content">
        {activeTab === 'upload' && <UploadTab />}
        {activeTab === 'library' && <LibraryTab />}
      </div>
    </div>
  );
};

export default ContentManagement;
